var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote2Blue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H13V7H7V6Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5H13V9.5H7V8.5Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11H7V12H10V11Z",
    fill: "#2F80ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17C4.44772 17 4 16.5523 4 16V4C4 3.44772 4.44772 3 5 3H15C15.5523 3 16 3.44772 16 4L16 12.9858C16 13.251 15.8946 13.5054 15.7071 13.6929L12.6929 16.7071C12.5054 16.8946 12.251 17 11.9858 17H5ZM11 15.6V13C11 12.4477 11.4477 12 12 12H14.6L14.6 4.4L5.4 4.4V15.6H11ZM14.0099 13.4L12.4 15.0099V13.4H14.0099Z",
    fill: "#2F80ED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote2Blue);
export default __webpack_public_path__ + "static/media/note-2_blue.221e1ab4.svg";
export { ForwardRef as ReactComponent };